export enum PathEnum {
	AUTH = "auth",
	LOGIN = "login",
	COMPLETE_REGISTRATION = "complete-registration",
	FORGOT_PASSWORD = "forgot-password",
	RESET_PASSWORD = "reset-password",

	PRIVATE = "private",
	HOME = "home",

	GUIDA = "guida",
	ACTIVITIES = "activities",
	LIBRARY = "library",
	IMAGE_LIBRARY = "image-library",
	USER_MANAGER = "user-manager",
	SIGN = "sign",
}
